// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";
const firebaseConfig = {
    apiKey: "AIzaSyDbaoYqHc9z4anVVyRZinL7dBjKiY5n_zY",
    authDomain: "snapchat-clone-yt-4b7ab.firebaseapp.com",
    projectId: "snapchat-clone-yt-4b7ab",
    storageBucket: "snapchat-clone-yt-4b7ab.appspot.com",
    messagingSenderId: "617764279654",
    appId: "1:617764279654:web:f6d4caca10620bbfc164a7",
    measurementId: "G-BG47ZCLZST"
  };
const firebaseApp=firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth= firebase.auth();
const storage = firebase.storage();
const provider = new firebase.auth.GoogleAuthProvider();

export {db,auth,provider,storage};